import { AccountComponent } from './account.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SelectSpaceComponent } from './components/select-space/select-space.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { InitialPageGuardService } from '../../core/router/initial-page-guard.service';
import { CoreStore } from '../../core/store/core.store';
import { TwoFactorUnlockComponent } from '../../shared/modules/two-factor/components/two-factor-unlock/two-factor-unlock.component';
import { Injectable, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuardService, getUserLocale, LocaleService } from '@ppl/auth';
import type { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';


@Injectable()
export class LocaleResolver {
  constructor(
    private store: CoreStore,
    private localeService: LocaleService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const locale = this.store.get(getUserLocale);

    return this.localeService.registerLocale(locale);
  }

}

const routes: Routes = [
  {
    path: '',
    canActivate: [InitialPageGuardService, AuthGuardService],
    resolve: {
      locale: LocaleResolver
    },
    component: AccountComponent,
    children: [
      { path: '', component: DashboardComponent },
      { path: 'user/edit', component: UserProfileComponent },
      {
        path: 'user/unlock',
        component: TwoFactorUnlockComponent,
        data: {
          redirectTo: 'user/edit'
        }
      },
      { path: 'select-space', component: SelectSpaceComponent },
      { path: 'select-space/:jwt', component: SelectSpaceComponent }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
  providers: [
    LocaleResolver
  ]
})
export class AccountRoutingModule {
}
